import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';
import LanguageSwitcher from '@/components/LanguageSwitcher';

const TERMS_ET = `
**KASUTUSTINGIMUSED**
*Viimati uuendatud: märts 2025*

**Polyus Plus OÜ** (registrikood 14890902, edaspidi „Teenusepakkuja") pakub töötajate kohaloleku jälgimise tarkvarateenust **Work+** (edaspidi „Teenus"). Teenuse kasutamisega kinnitate, et olete lugenud, mõistnud ja nõustute käesolevate kasutustingimustega.

---

**1. TEENUSE KIRJELDUS**

Work+ on veebipõhine tarkvarateenus, mis võimaldab ettevõtetel (klientidel) jälgida töötajate kohalolekut tööobjektidel GPS-asukoha andmete põhjal. Teenus mõõdab töötajate tööaega automaatselt, kui töötaja viibib määratud geograafilises tsoonis.

---

**2. LEPINGUOSALISED JA NENDE KOHUSTUSED**

**2.1 Kliendifirma kohustused:**
- Teavitada kõiki töötajaid GPS-jälgimisest kirjalikult enne teenuse kasutuselevõttu
- Saada töötajatelt nõusolek isikuandmete töötlemiseks vastavalt GDPR-ile
- Kasutada teenust ainult seaduslikel tööhõive eesmärkidel
- Tagada, et töötajad on vähemalt 18-aastased
- Mitte kasutada teenust töötajate jälgimiseks väljaspool tööaega ilma nende selge nõusolekuta

**2.2 Teenusepakkuja kohustused:**
- Osutada teenust vastavalt käesolevatele tingimustele
- Kaitsta kliendiandmeid vastavalt GDPR-ile ja privaatsuspoliitikale
- Tagada mõistlik süsteemi kättesaadavus (eesmärk 99% tööaeg)

---

**3. GPS-JÄLGIMINE JA TÖÖTAJATE ÕIGUSED**

**3.1 Jälgimise ulatus:** Süsteem salvestab töötaja GPS-koordinaate ainult siis, kui töötaja aktiveerib jälgimise ise rakenduses. Süsteem ei jälgi töötajaid pidevalt ega väljaspool tööaega.

**3.2 Kohustuslik teavitamine:** Kliendifirma peab töötajatele selgitama:
- Mida täpselt jälgitakse (asukoht tööobjektil tööajal)
- Miks jälgitakse (tööaja arvestus)
- Kes andmeid näeb (tööandja administraatorid)
- Kui kaua andmeid säilitatakse

**3.3 Töötaja kontroll:** Töötajal on alati võimalus GPS-jälgimine käsitsi peatada.

---

**4. TASUD JA ARVELDAMINE**

**4.1 Proovperiood:** Uued kliendid saavad 30 päeva tasuta proovperioodi.

**4.2 Tasulised plaanid:** Pärast proovperioodi on teenus tasuline vastavalt kehtivale hinnakirjale, mis on saadaval aadressil info@polyusplus.com.

**4.3 Maksed:** Arved esitatakse igakuiselt. Tasumata arve korral võib Teenusepakkuja peatada juurdepääsu teenusele.

---

**5. VASTUTUSE PIIRANGUD**

**5.1** Teenusepakkuja ei vastuta:
- GPS-asukoha ebatäpsuse tõttu tekkinud kahjude eest (GPS täpsus võib varieeruda 3–50 meetrit)
- Teenuse ajutise kättesaamatuse eest vääramatu jõu, kolmandate osapoolte infrastruktuuri rikete vm väliste põhjuste tõttu
- Kliendifirma poolt ebaseaduslikult rakendatud jälgimisest tulenevate kahjude eest
- Kaudse kahju, saamata jäänud tulu ega kolmandate isikute nõuete eest

**5.2** Teenusepakkuja maksimaalne vastutus on piiratud kliendi poolt viimase 3 kuu jooksul makstud teenustasudega.

**5.3 GPS täpsus:** GPS-põhine asukohamääramine ei ole 100% täpne. Kliendifirma peab arvestama võimaliku veaga tööaja arvestuses ning seda töötajatele selgitama.

---

**6. INTELLEKTUAALNE OMAND**

Kõik teenusega seotud intellektuaalomandi õigused kuuluvad Polyus Plus OÜ-le. Kliendile antakse ainult piiratud, üleloovutamatu litsents teenuse kasutamiseks lepingu kehtivusajal.

---

**7. KONFIDENTSIAALSUS**

Mõlemad pooled kohustuvad hoidma konfidentsiaalsena teise poole ärisaladused ning mitte avaldama neid kolmandatele isikutele ilma kirjaliku nõusolekuta.

---

**8. LEPINGU LÕPETAMINE**

**8.1** Klient võib lepingu lõpetada igal ajal, saates e-kirja aadressile info@polyusplus.com.

**8.2** Teenusepakkuja võib lepingu lõpetada, kui klient rikub oluliselt käesolevaid tingimusi, ei maksa arveid 30 päeva jooksul või kasutab teenust ebaseaduslikel eesmärkidel.

**8.3** Lepingu lõppemisel kustutatakse kõik kliendiandmed 30 päeva jooksul, välja arvatud andmed, mida Teenusepakkuja on kohustatud seaduse alusel säilitama.

---

**9. KOHALDATAV ÕIGUS**

Käesolevale lepingule kohaldatakse Eesti Vabariigi õigust. Vaidlused lahendatakse Harju Maakohtus.

---

**10. KONTAKT**

Polyus Plus OÜ  
Registrikood: 14890902  
E-post: info@polyusplus.com
`;

const TERMS_EN = `
**TERMS OF SERVICE**
*Last updated: March 2025*

**Polyus Plus OÜ** (registry code 14890902, hereinafter "Service Provider") provides the employee presence tracking software service **Work+** (hereinafter "Service"). By using the Service, you confirm that you have read, understood, and agree to these Terms of Service.

---

**1. SERVICE DESCRIPTION**

Work+ is a web-based software service that enables companies (clients) to track employee presence at work sites based on GPS location data. The service automatically measures employee working hours when the employee is within a defined geographic zone.

---

**2. PARTIES AND THEIR OBLIGATIONS**

**2.1 Client company obligations:**
- Notify all employees of GPS tracking in writing before implementing the service
- Obtain employee consent for personal data processing in accordance with GDPR
- Use the service only for lawful employment purposes
- Ensure that employees are at least 18 years of age
- Not use the service to monitor employees outside working hours without their explicit consent

**2.2 Service Provider obligations:**
- Provide the service in accordance with these terms
- Protect client data in accordance with GDPR and the Privacy Policy
- Ensure reasonable system availability (target 99% uptime)

---

**3. GPS TRACKING AND EMPLOYEE RIGHTS**

**3.1 Scope of tracking:** The system records an employee's GPS coordinates only when the employee activates tracking themselves in the application. The system does not continuously track employees outside working hours.

**3.2 Mandatory notification:** The client company must explain to employees:
- What exactly is being tracked (location at work site during working hours)
- Why it is tracked (time and attendance recording)
- Who sees the data (employer administrators)
- How long data is retained

**3.3 Employee control:** Employees can always manually stop GPS tracking.

---

**4. FEES AND BILLING**

**4.1 Trial period:** New clients receive a 30-day free trial period.

**4.2 Paid plans:** After the trial period, the service is paid according to the current price list available at info@polyusplus.com.

**4.3 Payments:** Invoices are issued monthly. In the event of an unpaid invoice, the Service Provider may suspend access to the service.

---

**5. LIMITATION OF LIABILITY**

**5.1** The Service Provider is not liable for:
- Damages caused by GPS location inaccuracy (GPS accuracy may vary from 3–50 meters)
- Temporary unavailability of the service due to force majeure, third-party infrastructure failures, or other external causes
- Damages resulting from unlawfully applied tracking by the client company
- Indirect damages, lost revenue, or third-party claims

**5.2** The Service Provider's maximum liability is limited to the service fees paid by the client in the last 3 months.

**5.3 GPS accuracy:** GPS-based location determination is not 100% accurate. The client company must account for possible errors in time tracking and explain this to employees.

---

**6. INTELLECTUAL PROPERTY**

All intellectual property rights related to the service belong to Polyus Plus OÜ. The client is granted only a limited, non-transferable license to use the service during the term of the agreement.

---

**7. CONFIDENTIALITY**

Both parties undertake to keep confidential the other party's trade secrets and not to disclose them to third parties without written consent.

---

**8. TERMINATION**

**8.1** The client may terminate the agreement at any time by sending an email to info@polyusplus.com.

**8.2** The Service Provider may terminate the agreement if the client materially breaches these terms, fails to pay invoices within 30 days, or uses the service for illegal purposes.

**8.3** Upon termination, all client data will be deleted within 30 days, except for data that the Service Provider is legally required to retain.

---

**9. GOVERNING LAW**

This agreement is governed by the laws of the Republic of Estonia. Disputes shall be resolved in Harju County Court.

---

**10. CONTACT**

Polyus Plus OÜ  
Registry code: 14890902  
Email: info@polyusplus.com
`;

export default function Terms() {
  const { language } = useLanguage();
  const [lang, setLang] = useState(language === 'et' ? 'et' : 'en');

  const content = lang === 'et' ? TERMS_ET : TERMS_EN;

  const renderMarkdown = (text) => {
    return text.split('\n').map((line, i) => {
      if (line.startsWith('**') && line.endsWith('**') && !line.slice(2, -2).includes('**')) {
        return <h2 key={i} className="text-xl font-bold text-white mt-8 mb-3">{line.slice(2, -2)}</h2>;
      }
      if (line.startsWith('---')) {
        return <hr key={i} className="border-wp-dark/50 my-4" />;
      }
      if (line.startsWith('*') && line.endsWith('*') && !line.startsWith('**')) {
        return <p key={i} className="text-wp-light/40 text-sm italic mb-4">{line.slice(1, -1)}</p>;
      }
      if (line.startsWith('**') && line.includes('**')) {
        const parts = line.split(/\*\*/g);
        return (
          <p key={i} className="text-wp-light/80 mb-2 leading-relaxed">
            {parts.map((part, j) => j % 2 === 1 ? <strong key={j} className="text-white">{part}</strong> : part)}
          </p>
        );
      }
      if (line.startsWith('- ')) {
        return <li key={i} className="text-wp-light/70 ml-6 mb-1 list-disc leading-relaxed">{line.slice(2)}</li>;
      }
      if (line === '') {
        return <div key={i} className="h-2" />;
      }
      return <p key={i} className="text-wp-light/70 mb-2 leading-relaxed">{line}</p>;
    });
  };

  return (
    <div className="min-h-screen bg-[#0a0a0f] p-4">
      <div className="absolute top-4 right-4 z-20">
        <LanguageSwitcher variant="auth" />
      </div>

      <div className="max-w-3xl mx-auto pt-16 pb-20">
        <div className="flex items-center justify-between mb-8">
          <Link to="/register-company" className="text-wp-light/50 hover:text-wp-light text-sm transition-colors">
            ← {lang === 'et' ? 'Tagasi registreerimisele' : 'Back to registration'}
          </Link>
          <div className="flex gap-2">
            <button
              onClick={() => setLang('et')}
              className={`px-3 py-1 rounded-lg text-sm transition-colors ${lang === 'et' ? 'bg-indigo-600 text-white' : 'text-wp-light/50 hover:text-wp-light'}`}
            >
              ET
            </button>
            <button
              onClick={() => setLang('en')}
              className={`px-3 py-1 rounded-lg text-sm transition-colors ${lang === 'en' ? 'bg-indigo-600 text-white' : 'text-wp-light/50 hover:text-wp-light'}`}
            >
              EN
            </button>
          </div>
        </div>

        <div className="glass-card rounded-2xl p-8">
          <div className="prose prose-invert max-w-none">
            {renderMarkdown(content)}
          </div>
        </div>
      </div>
    </div>
  );
}
